import { useMutation } from '@tanstack/react-query';

import { type ParkingGateways } from 'src/features/parkingManagement/api/ParkingGatewayAPIs/useParkingGateways.ts';
import axios from 'src/lib/axios.ts';
import { type MutationConfig } from 'src/lib/react-query.ts';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex.ts';

import type { Coordinates } from 'src/features/parkingManagement/types/parking.ts';

const RESOURCE = '/parkings/parking-gateways/:id/';

interface DTO {
    id: string;
    coordinates?: Coordinates;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ id, ...data }: DTO): Promise<ParkingGateways> => {
    return axios.patch(formatResourcePath(RESOURCE, { id }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateParkingGateway };
